import { Configuration } from '../../../../../hooks/useConfiguration';
import { PerformerType } from '../../../constants/performer.constants';
import { RequestBody } from '../../api/connector';
import { EnrollmentContextService } from '../enrollment-context';
import { consentsMapper } from './consents';
import { patientMapper } from './patient';
import { servicesMapper } from './services';

export const PerformerValues = {
	patient: 'Patient',
	caregiver: 'RelatedPerson',
};

export const mapper = (
	configuration: Configuration,
	enrollmentContext: EnrollmentContextService
): RequestBody => {
	return {
		consents: consentsMapper(configuration.product.services, enrollmentContext),
		serviceEnrollments: servicesMapper(configuration.product.services, enrollmentContext),
		patient: !enrollmentContext.isFastTrack(configuration.product)
			? patientMapper(configuration.forms, enrollmentContext)
			: undefined,
		performer: {
			type:
				enrollmentContext.input.performer === PerformerType.PATIENT
					? PerformerValues.patient
					: PerformerValues.caregiver,
		},
		product: configuration.product.params.brandName?.toLowerCase(),
	};
};
